import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-next-orange" }
const _hoisted_2 = ["value"]
const _hoisted_3 = ["value", "type", "placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.labelVisible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["font-bold pb-2 text-sm", _ctx.labelClass])
        }, [
          _createTextVNode(_toDisplayString(_ctx.field_name), 1),
          _withDirectives(_createElementVNode("span", _hoisted_1, " *", 512), [
            [_vShow, _ctx.required]
          ])
        ], 2))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default", {}, () => [
      (_ctx.type==='date')
        ? (_openBlock(), _createElementBlock("input", _mergeProps({
            key: 0,
            value: _ctx.modelValue,
            onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
            type: "date"
          }, _ctx.inputAttrs, { class: "p-7px bg-next-gray-md-dark hover:bg-white w-full" }), null, 16, _hoisted_2))
        : (_openBlock(), _createElementBlock("input", _mergeProps({
            key: 1,
            value: _ctx.modelValue,
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
            type: _ctx.type,
            placeholder: _ctx.placeholder === undefined ? _ctx.field_name : _ctx.placeholder
          }, _ctx.inputAttrs, { class: "p-2 bg-next-gray-md-dark hover:bg-white w-full" }), null, 16, _hoisted_3))
    ]),
    _renderSlot(_ctx.$slots, "help"),
    _renderSlot(_ctx.$slots, "errors", {}, () => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (e, i) => {
        return (_openBlock(), _createElementBlock("small", {
          key: i,
          class: "text-next-orange"
        }, _toDisplayString(e), 1))
      }), 128))
    ])
  ], 64))
}